﻿import { useUserContext, HelmetDexteel } from "@dexteel/mesf-core";
import { useNavigate, useParams } from "react-router-dom";
import { TaskListProvider } from "./context/taskListContext";
import { useInitialValues } from "./filters/hooks/useInitialValues";
import { TaskListByDownHours } from "./task-list-by-down-hours/task-list-by-down-hours";

export default function TaskListIndex() {
	const { AssetIdParam } = useParams();
	const navigate = useNavigate();

	const {
		state: { defaultAreaId },
	} = useUserContext();

	useInitialValues();

	if (!AssetIdParam) {
		navigate(`/task-list/downday/${defaultAreaId}`, { replace: true });
		return null;
	}

	return (
		<>
			<HelmetDexteel title="Task List" />
			<TaskListProvider>
				<TaskListByDownHours />
			</TaskListProvider>
		</>
	);
}
